const _temp0 = require("url:./amb-loop-1.m4a");
const _temp1 = require("url:./amb-loop-2.m4a");
const _temp2 = require("url:./amb-loop-3.m4a");
module.exports = {
  "amb-loop-1": _temp0,
  "amb-loop-2": _temp1,
  "amb-loop-3": _temp2
}